module.exports = __webpack_public_path__ + "static/media/bdsunglasses_home.a49a7e26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/BlackDiamond/bdsunglasses_home.jpg
// module id = 648
// module chunks = 0